import { aIsPlaying, useAtom } from "~/atoms"
import { PauseIcon, PlayIcon } from "~/components"
import { Tooltip } from "~/components/ui"
import useIsPhone from "~/hooks/useIsPhone"
import { cn } from "~/utils"
import { ControlButton } from "./control-button"

export default function PlayControl({ className }: { className?: string }) {
  const [isPlaying, setIsPlaying] = useAtom(aIsPlaying)
  const isPhone = useIsPhone()

  return (
    <Tooltip.Provider>
      <Tooltip delayDuration={200}>
        <Tooltip.Trigger asChild>
          <ControlButton
            onClick={() => setIsPlaying(!isPlaying)}
            className={cn(className, isPhone && "!h-8 !px-3")}
            aria-label={isPlaying ? "Pause" : "Play"}
          >
            {isPlaying ? (
              <PauseIcon className="h-4 w-4 text-white sm:h-6 sm:w-6" />
            ) : (
              <PlayIcon className="h-4 w-4 text-white sm:h-6 sm:w-6" />
            )}
          </ControlButton>
        </Tooltip.Trigger>
        <Tooltip.Content>{isPlaying ? "Pause" : "Play"}</Tooltip.Content>
      </Tooltip>
    </Tooltip.Provider>
  )
}
